<template>
    <div>
        <v-tabs
                slot="extension"
                v-model="model"
                centered
                color="secondary"
                slider-color="primary"
                class="elevation-10"
        >
            <h3 class="text-xs-center" style="padding: 13px;">
                {{ sample ? sample.status_name : '' }}
            </h3>
            <v-spacer></v-spacer>
            <v-tab
                    href="#tab-order"
            >
                Sample request
            </v-tab>
            <v-tab
                    href="#tab-documents"
            >
                My documents
            </v-tab>
            <v-spacer></v-spacer>
            <v-btn
                    :href="BASE + 'sample-order/' + id + '?download_token=' + download_token"
                    target="_blank"
            >
                Download sample request
            </v-btn>
        </v-tabs>



        <v-tabs-items
                v-model="model"
                class="elevation-10"

        >
            <v-tab-item
                    value="tab-order"
                    lazy
                    :transition="false"
                    :reverse-transition="false"
            >
                <v-card flat>
                    <OrderComponent :sample="sample" v-if="model == 'tab-order' && sample" v-on:updated="getSampleOrderDetail"></OrderComponent>
                </v-card>
            </v-tab-item>
            <v-tab-item
                    value="tab-documents"
                    lazy
                    :transition="false"
                    :reverse-transition="false"
            >
                <v-card flat>
                    <DocumentsComponent :sample="sample" v-if="model == 'tab-documents'" :order_id="id" v-on:updated="getSampleOrderDetail"></DocumentsComponent>
                </v-card>
            </v-tab-item>
        </v-tabs-items>
    </div>
</template>

<script>
    import { BASE } from "../../../config";
    import DocumentsComponent from './views/DocumentsComponent';
    import OrderComponent from './views/OrderComponent';

    export default {
        props: ['id'],
        data () {
            return {
                model: 'tab-order',
                sample: null,
                comments: null,
                BASE: BASE,
                download_token: null
            }
        },
        created () {
            this.checkUser();
            this.setSectionTitle();
            this.getSampleOrderDetail();
        },
        methods: {
            checkUser() {
                this.$store.dispatch('checkAccessToken').then((res) => {
                    this.download_token = this.$store.getters.getUser.download_token;
                }).catch((error) => {

                });
            },
            setSectionTitle () {
                this.$store.dispatch('setSectionTitle', {
                    title: 'Sample request detail.'
                });
            },
            getSampleOrderDetail () {
                this.$store.dispatch('getSampleOrderDetail', {
                    id: this.id
                }).then((res) => {

                    this.sample = res.data.data;

                }).catch((error) => {

                });
            }
        },
        components: {
            DocumentsComponent,
            OrderComponent
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/fnt/samples/DetailComponent.vue